<template>
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-12">
        <indexHeader
          :title="$t('Companies')"
          :description="$t('From Here You Can Control Your Own Companies')"
        />
        <indexTable
          :searchText="$t('Search For A Company')"
          :emptyTableText="$t('There Are NoCompanies')"
          :emptyTableSubText="$t('Try adding some items to the table and try again')"
          :buttonRole="$checkRole('companies_add')"
          :localData="true"
          :cloumns="[
            {
              column: 'name',
              title: $t('companyName'),
              type: 'text',
              sort: true
            },
            {
              column: 'address1',
              title: $t('company address'),
              type: 'text',
              sort: true
            },
            {
              column: 'city',
              title: $t('City of the company'),
              type: 'text',
              sort: true
            },
            {
              column: 'country',
              title: $t('country of the company'),
              type: 'text',
              sort: true
            },
            {
              column: 'options',
              title: $t('Settings'),
              type: 'options',
              options: [
                {
                  name: 'edit',
                  role: $checkRole('companies_edit')
                },
                {
                  name: 'delete',
                  role: $checkRole('companies_delete')
                }
              ]
            }
          ]"
          :deleteText="{
            attention: $t('Attention'),
            areYouReallySureToDeleteTheItem: $t('Are you really sure to delete the item'),
            close: $t('Close'),
            confirm: $t('Confirm'),
            loading: $t('Loading')
          }"
        />
      </div>
    </div>
  </div>
</template>
<script>
import indexHeader from '@/elements/index/indexHeader.vue'
import indexTable from '@/elements/index/indexTable.vue'
export default {
  data() {
    return {
      path: '/companies'
    }
  },
  components: {
    indexHeader,
    indexTable
  }
}
</script>
